import { render } from "./emailEditor.vue?vue&type=template&id=5bb24298&scoped=true"
import script from "./emailEditor.vue?vue&type=script&lang=js"
export * from "./emailEditor.vue?vue&type=script&lang=js"

import "./emailEditor.vue?vue&type=style&index=0&id=5bb24298&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb24298"]])

export default __exports__